import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import Pagination from "../General/Pagination";
import FeeSystemMenu from "./FeeSystemMenu";
import RightsCheck from "../General/RightsCheck";

function AdvanceReceived() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [totalAdvance, setTotalAdvance] = useState("");
  const [totalRemaining, setTotalRemaining] = useState("");
  const [StartDate, setStartDate] = useState(null);
  const [EndDate, setEndDate] = useState(null);

  const [ledger, setLedger] = useState([]);
  const [showFilters, setShowFilters] = useState(true);

  document.title = "Advance Received Report";

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchReport = (pageOverride) => {
    const pg = pageOverride != null ? pageOverride : pageNo;
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      StartDate: StartDate,
      EndDate: EndDate,
      pageNo: pg,
      pageSize: pageSize,
    };

    axios({
      method: "post",
      url: config.base_url + "FeeSystem/GetAdvanceReceivedReport",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setLedger(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords);
          setTotalAdvance(response.data.totalAdvance);
          setTotalRemaining(response.data.totalRemaining || "");
        } else {
          setLedger([]);
          setTotalRecords(0);
          setTotalAdvance("");
          setTotalRemaining("");
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  useEffect(() => {
    if (StartDate && EndDate) {
      fetchReport();
    }
  }, [pageNo, pageSize]);

  const GetReport = () => {
    if (!StartDate || !EndDate) {
      toast.error("Please select start and end date.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    setPageNo(1);
    fetchReport(1);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (ledger != null && ledger.length > 0) {
      return ledger.map((item, index) => (
        <tr key={index}>
          <td>{item.Serial_No}</td>
          <td>{moment(item.Dated).format(config.date_format)}</td>
          <td>{Number(item.TotalAdvanceReceived).toLocaleString()}</td>
          <td>{Number(item.RemainingAdvance).toLocaleString()}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="4">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ToastContainer />
      <RightsCheck />
      <FeeSystemMenu />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Advance Received
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Advance Received Report</div>
                <p className="text-muted small mb-0">
                  Source: <code>tblAdvancePayment</code> — advance received and remaining balance per receipt.
                </p>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <button
                    onClick={() => setShowFilters((prev) => !prev)}
                    className="button button-white button-icon"
                    type="button"
                  >
                    {showFilters ? "Hide Filters" : "Show Filters"}
                    <i className="ri-filter-3-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`collapse ${showFilters ? "show" : ""}`} id="collapseFilteres">
          <div className="collapse show" id="collapseFilteres">
            <div className="page-content">
              <div className="container">
                <div className="card mb-2">
                  <div className="card-body p-md-4">
                    <div className="row align-items-end gy-3">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Start Date :</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setStartDate(e.target.value)}
                            max={moment().format(config.date_format_input)}
                            min={moment()
                              .subtract(2, "months")
                              .format(config.date_format_input)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>End Date :</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setEndDate(e.target.value)}
                            max={moment().format(config.date_format_input)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-2 offset-md-4">
                        <div className="form-group text-end">
                          <button
                            type="button"
                            onClick={GetReport}
                            className="button button-primary w-100"
                          >
                            View Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <table className="table table-theme">
                  <thead>
                    <tr>
                      <th colSpan="4">{totalRecords} Records Found!</th>
                    </tr>
                    <tr>
                      <th>Serial No</th>
                      <th>Received Date</th>
                      <th>Advance Received (Rs.)</th>
                      <th>Remaining Advance (Rs.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="4">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {renderLedger()}
                        {ledger != null && ledger.length > 0 && (
                          <tr>
                            <th colSpan={2} className="text-end">
                              Total ({totalRecords} receipts):
                            </th>
                            <th>{totalAdvance}</th>
                            <th>{totalRemaining}</th>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
                {totalRecords > 10 && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page Size
                          </label>
                          <div className="form-group">
                            <select
                              className="form-select"
                              style={{ width: "100px" }}
                              defaultValue="50"
                              onChange={(e) => {
                                setPageNo(1);
                                setPageSize(parseInt(e.target.value, 10));
                              }}
                            >
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="card mt-2">
              <div className="card-body p-md-4">
                <div className="row text-end align-items-center">
                  <div className="col-md-2 offset-md-10">
                    <NavLink
                      className={`button button-primary w-100 ${
                        ledger.length === 0 || !StartDate || !EndDate
                          ? "disabled"
                          : ""
                      }`}
                      to={`/FeeSystem/PrintAdvanceReceived/?start=${StartDate || ""}&end=${EndDate || ""}`}
                      target="_blank"
                    >
                      Print Report
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvanceReceived;
